<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
<!--              <CTab  :title="$t('areas')">-->
<!--                <Areas/>-->
<!--              </CTab>-->
<!--              <CTab  :title="$t('districts')">-->
<!--                <District/>-->
<!--              </CTab>-->
              <CTab title="متد های فروش"  v-if="get_access('sell_method')">
                <SaleMethods/>
              </CTab>
              <CTab :title="$t('cars')">
                <InsertWheicle/>
              </CTab>


              <CTab title="فروش مستقیم تامین کننده" v-if="get_access('sell_supplier_direct')">
                <DirectSellSupplier/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import BTabs from "../../tabs/BTabs";
import SaleMethods from "@/views/panel/accounting/SaleMethods";
import InsertWheicle from "@/views/panel/delivery/InsertWheicle";
import DirectSellSupplier from "./DirectSellSupplier";
export default {
  name: 'SaleSettingsComponent',
  components: {
    BTabs,
    SaleMethods,
    InsertWheicle,
    DirectSellSupplier
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("sale_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

    'active_tab': function () {
      localStorage.setItem("sale_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
